// 活动管理
export default [
  {
    path: "/activity",
    name: "activity",
    meta: { title: "活动管理" },
    component: () => import("../views/activity/index"),
    children: [
      {
        path: "/activity/list",
        name: "activityList",
        meta: { title: "活动列表", isMenu: true },
        component: () => import("../views/activity/list"),
      },
      {
        path: "/activity/audit",
        name: "activityAudit",
        meta: { title: "活动审核", isMenu: true },
        component: () => import("../views/activity/audit"),
      },
      {
        path: "/activity/order",
        name: "activityOrder",
        meta: { title: "活动订单", isMenu: true },
        component: () => import("../views/activity/order"),
      },
      {
        path: "/activity/category",
        name: "activityCategory",
        meta: { title: "活动分类", isMenu: true },
        component: () => import("../views/activity/category"),
      },
      {
        path: "/activity/wonderful",
        name: "activityWonderful",
        meta: { title: "精彩时刻", isMenu: true },
        component: () => import("../views/activity/wonderful"),
      },
      {
        path: "/activity/list/apply",
        name: "activityApply",
        meta: { title: "新增活动" },
        component: () => import("../views/activity/detail/apply"),
      },
      {
        path: "/activity/list/details",
        name: "activityDetails",
        meta: { title: "活动详情" },
        component: () => import("../views/activity/detail/details"),
      },
      {
        path: "/activity/list/applyList",
        name: "activityApplyList",
        meta: { title: "报名明细" },
        component: () => import("../views/activity/detail/applyList"),
      },
      {
        path: "/activity/order/details",
        name: "activityOrderDetails",
        meta: { title: "活动订单详情" },
        component: () => import("../views/activity/detail/orderDetail"),
      },
      {
        path: "/activity/order/auditDetail",
        name: "activityAuditDetail",
        meta: { title: "活动审核详情" },
        component: () => import("../views/activity/detail/auditDetail"),
      },
    ],
  },
]
